/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UsageUpdate = {
    properties: {
        amount: {
            type: 'number',
            isNullable: true,
            format: 'float',
        },
        readDate: {
            type: 'string',
            isNullable: true,
            format: 'date-time',
        },
    },
};